import { render } from "./PageBikou.vue?vue&type=template&id=1e1fd0df&scoped=true"
import script from "./PageBikou.vue?vue&type=script&lang=js"
export * from "./PageBikou.vue?vue&type=script&lang=js"

import "./PageBikou.vue?vue&type=style&index=0&id=1e1fd0df&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1fd0df"]])

export default __exports__